import { useDisclosure, Image, Box } from "@chakra-ui/react";
import ImageModal from "./ImageModal";
import React from "react";

interface ImageWithModalProps {
  image: string;
  alt: string;
  fullSizeImage: string;
  isScreenshot: boolean;
}

const ImageWithModal = ({
  image,
  alt,
  fullSizeImage,
  isScreenshot,
}: ImageWithModalProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box
        overflow="hidden"
        height="100%"
        mr={isScreenshot ? "-8px" : "0"}
        background="black"
      >
        <Image
          src={image}
          alt={alt}
          cursor="pointer"
          onClick={onOpen}
          height="100%"
          width="100%"
          objectFit={isScreenshot ? "cover" : "contain"}
        />
      </Box>
      <ImageModal
        isOpen={isOpen}
        onClose={onClose}
        imageUrl={fullSizeImage}
        alt="Fullscreen view of image"
      />
    </>
  );
};

export default ImageWithModal;
